import { useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import toast from "react-hot-toast";
import ProfileNav from "../components/ProfileNav";
import Pagination from "../components/Pagination";
import {
  fetchConfigRequests,
  fetchMerchantRequests,
} from "../services/merchant";
import { CiUnlock } from "react-icons/ci";
import ApprovalMerchantRequestModal from "./ApprovalMerchantRequestModal";
import DeclineMerchantRequestModal from "./DeclineMerchantRequestModal";

const EditMerchantRequests = () => {
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showOptions, setShowOptions] = useState(null);
  const queryClient = useQueryClient();

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setShowOptions(null); // Reset options when clicking a different user
    // Close edit user popup when a user is clicked
  };

  const getMerchantRequests = async () => {
    try {
      const res = await fetchMerchantRequests();
      //setTotalCount(res.data?.totalRecords);
      return res;
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleApprove = async (requests) => {
    setSelectedUser(requests);
    setShowOptions(null);
    setShowApprovalModal(true);
  };

  const handleDecline = async (requests) => {
    setSelectedUser(requests);
    setShowOptions(null);
    setShowDeclineModal(true);
  };

  const query = useQuery({
    queryKey: ["getMerchantRequests"],
    queryFn: getMerchantRequests,
  });

  const handleSvgClick = (userId, event) => {
    setShowOptions((prev) => (prev === userId ? null : userId));
    // setShowDocument(false);
    // setCreateUserVisible(false);
    // setEditUserVisible(false);
  };

  // const paginate = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  return (
    <div className="h-screen">
      <article className="h-screen flex gap-4">
        <section className="w-[48%] flex-grow-[6] pt-4 ">
          <div className="flex items-center justify-between mb-16">
            <h1 className="text-2xl font-bold text-navy-blue">
              Merchant Requests
            </h1>
            <div>
              <ProfileNav />
            </div>
            {/* <button
                  className="bg-text-orange text-sm font-semibold w-[130px] h-[40px] rounded-md text-white"
                  onClick={handleNewUserClick}
                >
                  {" "}
                  + New User
                </button> */}
          </div>
          <div className="bg-white w-full">
            <div className="flex items-center justify-end gap-3 px-2">
              <p className="border-r pr-5 font-normal text-[12px]">
                1 Selected
              </p>
              <span>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3367_2872)">
                    <path
                      d="M20.3333 14.3333V18.5C20.3333 18.9583 19.9583 19.3333 19.5 19.3333H9.5C9.04167 19.3333 8.66667 18.9583 8.66667 18.5V14.3333C8.66667 13.875 8.29167 13.5 7.83333 13.5C7.375 13.5 7 13.875 7 14.3333V19.3333C7 20.25 7.75 21 8.66667 21H20.3333C21.25 21 22 20.25 22 19.3333V14.3333C22 13.875 21.625 13.5 21.1667 13.5C20.7083 13.5 20.3333 13.875 20.3333 14.3333ZM15.3333 14.0583L16.9 12.4917C17.225 12.1667 17.75 12.1667 18.075 12.4917C18.4 12.8167 18.4 13.3417 18.075 13.6667L15.0833 16.6583C14.7583 16.9833 14.2333 16.9833 13.9083 16.6583L10.9167 13.6667C10.5917 13.3417 10.5917 12.8167 10.9167 12.4917C11.2417 12.1667 11.7667 12.1667 12.0917 12.4917L13.6667 14.0583V6.83333C13.6667 6.375 14.0417 6 14.5 6C14.9583 6 15.3333 6.375 15.3333 6.83333V14.0583Z"
                      fill="#323232"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3367_2872">
                      <rect width="28" height="28" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 8.75C5.69036 8.75 6.25 9.30964 6.25 10C6.25 10.6904 5.69036 11.25 5 11.25C4.30964 11.25 3.75 10.6904 3.75 10C3.75 9.30964 4.30964 8.75 5 8.75Z"
                    fill="#1C1C1C"
                  />
                  <path
                    d="M10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75Z"
                    fill="#1C1C1C"
                  />
                  <path
                    d="M16.25 10C16.25 9.30964 15.6904 8.75 15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25C15.6904 11.25 16.25 10.6904 16.25 10Z"
                    fill="#1C1C1C"
                  />
                </svg>
              </span>
            </div>
            <div className="flex justify-end px-3">
              {/* <div className="flex items-center gap-2">
                    <p className="border-r pr-5 text-sm font-semibold">
                      System Users
                    </p>
                    <div className="flex items-center gap-2">
                      <div className="bg-black w-[6px] h-[6px] rounded-full"></div>
                      <p className="text-[12px] font-normal">Active</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="bg-black w-[6px] h-[6px] rounded-full"></div>
                      <p className="text-[12px] font-normal">Inactive</p>
                    </div>
                  </div> */}
              {/* <Pagination
                totalItems={totalCount}
                itemsPerPage={itemsPerPage}
                paginate={paginate}
                currentPage={currentPage}
              /> */}
            </div>
            <table className="w-full">
              <thead>
                <tr className="text-left border-b-2">
                  <th className="px-3">
                    <div className="font-normal">ID</div>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p className="w-[54px]">Merchant Id</p>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p className="w-[54px]">Terminal Id</p>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p className="w-[54px]">Amex Id</p>
                  </th>
                  <th className="px-3 py-3 font-normal text-[12px] border-r text-black-shade/40">
                    <p>Merchant Name</p>
                  </th>
                  <th className="px-3 border-r font-normal text-[12px] text-black-shade/40">
                    <p className="w-[54px]">Email</p>
                  </th>
                  <th className="px-3 border-r font-normal text-[12px] text-black-shade/40">
                    <p className="w-[54px]">IsEnabled</p>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="cursor-pointer relative">
                {query?.data?.data?.map((requests, index) => (
                  <tr
                    key={requests.id}
                    className="bg-white border-b text-[12px] text-black-shade font-normal hover:bg-black-shade/5"
                  >
                    <td className="py-2 px-3">{requests.Id}</td>

                    <td
                      className="py-2 px-3 w-[90px]"
                      onClick={() => handleUserClick(requests)}
                    >
                      <div className="text-wrap">{requests.MerchantId}</div>
                    </td>

                    {/* <span className="flex items-center gap-6 justify-around"> */}

                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(requests)}
                    >
                      <div className="">{requests.TerminalId}</div>
                    </td>
                    <td
                      className="py-2 px-3 w-[142px]"
                      onClick={() => handleUserClick(requests)}
                    >
                      <div>{requests.AmexId}</div>
                    </td>
                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(requests)}
                    >
                      <span className="">{requests.MerchantName}</span>
                    </td>
                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(requests)}
                    >
                      <span className="">{requests.Email}</span>
                    </td>
                    <td
                      className="py-2 px-3"
                      onClick={() => handleUserClick(requests)}
                    >
                      <span className="">{requests.isEnabled}</span>
                    </td>

                    {/* <section className="relative"> */}
                    <td className="relative">
                      <svg
                        className="mt-2"
                        width="20"
                        height="8"
                        viewBox="0 0 19 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={(event) => handleSvgClick(requests.Id, event)}
                      >
                        <g opacity="0.3">
                          <path
                            d="M13.4874 0.512567C12.804 -0.170848 11.696 -0.170848 11.0126 0.512567C10.3291 1.19598 10.3291 2.30402 11.0126 2.98744C11.696 3.67085 12.804 3.67085 13.4874 2.98744C14.1709 2.30405 14.1709 1.19601 13.4874 0.512567Z"
                            fill="#030229"
                          />
                          <path
                            d="M8.23744 0.512567C7.55402 -0.170848 6.44598 -0.170848 5.76257 0.512567C5.07915 1.19598 5.07915 2.30402 5.76257 2.98744C6.44598 3.67085 7.55402 3.67085 8.23744 2.98744C8.92085 2.30405 8.92085 1.19601 8.23744 0.512567Z"
                            fill="#030229"
                          />
                          <path
                            d="M2.98744 0.512567C2.30402 -0.170848 1.19598 -0.170848 0.512564 0.512567C-0.170852 1.19598 -0.170852 2.30402 0.512564 2.98744C1.19598 3.67085 2.30402 3.67085 2.98744 2.98744C3.67085 2.30405 3.67085 1.19601 2.98744 0.512567Z"
                            fill="#030229"
                          />
                        </g>
                      </svg>

                      {/* EditDeleteModal within the same page */}
                      {showOptions === requests.Id && (
                        <div className="bg-white border absolute right-4 top-10 z-[2000] flex flex-col gap-3 items-center p-2 w-[110px] rounded-[10px] shadow-md">
                          {/* <button className="flex items-center gap-2 pl-2 w-[100px] h-[27px] text-white rounded-[5px] font-[Nunito] text-xs bg-black">
                            <span>
                              <IoDocumentText />
                            </span>
                            <p>View Details</p>
                          </button> */}
                          <button
                            className="flex items-center gap-2 pl-2 w-[90px] h-[27px] text-[#5B93FF] rounded-[5px] font-[Nunito] text-xs bg-[#5B93FF]/15"
                            onClick={() => handleApprove(requests)}
                          >
                            <svg
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M2.65683 7.09496L6.31783 2.3606C6.51679 2.10529 6.58754 1.81012 6.52121 1.50958C6.46374 1.23636 6.29572 0.976572 6.04369 0.779493L5.42911 0.291277C4.89411 -0.134234 4.23088 -0.0894431 3.85063 0.398774L3.43944 0.932229C3.38638 0.998967 3.39964 1.09751 3.46597 1.15125C3.46597 1.15125 4.50501 1.98436 4.52712 2.00227C4.59787 2.06946 4.65092 2.15904 4.66419 2.26654C4.6863 2.47705 4.54039 2.67413 4.32373 2.70101C4.22204 2.71444 4.12477 2.68309 4.05402 2.62486L2.96192 1.75593C2.90886 1.71606 2.82927 1.72457 2.78506 1.77832L0.189641 5.13761C0.0216244 5.34813 -0.035855 5.62135 0.0216244 5.88561L0.353236 7.32339C0.370922 7.39953 0.437244 7.45328 0.516831 7.45328L1.97592 7.43537C2.24121 7.43089 2.48882 7.30995 2.65683 7.09496ZM4.69983 6.64712H7.07904C7.31116 6.64712 7.49996 6.83838 7.49996 7.07352C7.49996 7.30912 7.31116 7.49993 7.07904 7.49993H4.69983C4.4677 7.49993 4.27891 7.30912 4.27891 7.07352C4.27891 6.83838 4.4677 6.64712 4.69983 6.64712Z"
                                fill="#5B93FF"
                              />
                            </svg>
                            Approve
                          </button>
                          <button
                            className="flex items-center gap-2 pl-2 w-[90px] h-[27px] text-white font-[Nunito] rounded-[5px] text-xs bg-red-400"
                            onClick={() => handleDecline(requests)}
                          >
                            <CiUnlock />
                            Decline
                          </button>

                          {/* {user.isDisabled ? (
                                <button className="flex items-center gap-2 pl-2 w-[90px] h-[27px] text-[#5B93FF] font-[Nunito] rounded-[5px] text-xs bg-[#5B93FF]/15">
                                  <CiUnlock />
                                  Enable
                                </button>
                              ) : (
                                <button className="flex items-center gap-2 pl-2 w-[90px] h-[27px] text-[#E71D36] font-[Nunito] rounded-[5px] text-xs bg-[#E71D36]/15">
                                  <CiLock />
                                  Disable
                                </button>
                              )} */}
                        </div>
                      )}

                      {/* </section> */}
                      {/* </span> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </article>
      {showApprovalModal && (
        <ApprovalMerchantRequestModal
          setShowApprove={setShowApprovalModal}
          user={selectedUser}
        />
      )}
      {showDeclineModal && (
        <DeclineMerchantRequestModal
          setShowDecline={setShowDeclineModal}
          user={selectedUser}
        />
      )}
    </div>
  );
};

export default EditMerchantRequests;
